import React, { useState } from "react";
import { Button, Modal, message } from "antd";
import Cookies from "js-cookie";

export default function SupportMarkOfferOngoingButton({ loanType, offer, onUpdated }) {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!offer?.can_mark_ongoing) return null;

  const markOngoing = async () => {
    setBusy(true);
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/support/loans/${loanType}/offers/${offer.id}/mark-ongoing`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${Cookies.get("support_token")}`,
            Accept: "application/json",
          },
        }
      );
      const json = await response.json();
      if (!response.ok) throw new Error(json?.message || "Unable to mark offer ongoing.");
      setConfirming(false);
      message.success(json?.message || "Offer marked ongoing.");
      await onUpdated();
    } catch (error) {
      message.error(error.message || "Unable to mark offer ongoing.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button onClick={() => setConfirming(true)} style={{ borderRadius: 10, fontWeight: 800 }}>
        Mark ongoing
      </Button>
      <Modal
        title="Mark this loan ongoing?"
        open={confirming}
        onCancel={() => !busy && setConfirming(false)}
        onOk={markOngoing}
        okText="Mark ongoing"
        cancelText="Keep current status"
        confirmLoading={busy}
        cancelButtonProps={{ disabled: busy }}
        closable={!busy}
        maskClosable={!busy}
        keyboard={!busy}
      >
        <p>
          This will change the loan from {offer.lender?.name || "this lender"} to
          ongoing for support, the borrower, and the lender.
        </p>
        <p>The existing repayment schedule, payment records, and disbursement date will be preserved.</p>
      </Modal>
    </>
  );
}
